function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { View, Text, Button } from "./native";
import wrapComponent from "../core/wrapComponent";

function ErrorFallback({
  error,
  componentStack,
  resetErrorBoundary
}) {
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, null, "Something went wrong:"), /*#__PURE__*/React.createElement(Text, null, error === null || error === void 0 ? void 0 : error.message), /*#__PURE__*/React.createElement(Text, null, componentStack), /*#__PURE__*/React.createElement(Button, {
    onPress: resetErrorBoundary
  }, "Try again"));
}

function ErrorWrapper(_ref) {
  let {
    children
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    fallbackRender: props => /*#__PURE__*/React.createElement(ErrorFallback, props)
  }, rest), children);
}

export default wrapComponent(ErrorWrapper, {});